module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Light.ba03aa81.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Light.eot
// module id = 2257
// module chunks = 49